import TableListTickets, {
  TicketsPageProps,
} from "../../shared/components/organisms/TableListTickets";
import {
  useGetAllTicketsQuery,
  useGetSupportStaffTicketsQuery,
} from "./api/Ticket.api";
import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { selectUser } from "@/app/auth/auth.slice";
import IncidenceModal from "@/shared/components/organisms/IncidenceModal";
import { useFormik } from "formik";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { Select } from "@/shared/components/organisms/Select";
import { SelectAvatar } from "@/shared/components/organisms/SelectAvatar";
import { t } from "i18next";
import { useDebounce } from "@/shared/hooks/debounce";

const stateTickets = [
  {
    id: 1,
    name: "No leido",
    value: "No Read",
  },
  {
    id: 1,
    name: "leido",
    value: "Read",
  },
  {
    id: 1,
    name: "Escalado",
    value: "Technical Support",
  },
  {
    id: 1,
    name: "Resuelto",
    value: "Finished",
  },
];

export const TicketPage = () => {
  const user = useSelector(selectUser);
  const [openModalIncidence, setOpenModalIncidence] = useState(false);
  const [currenTicket, setCurrenTicket] = useState<
    TicketsPageProps | undefined
  >(undefined); // Type currenTicket

  const formik = useFormik({
    initialValues: {
      search: "",
      state: { id: 0, name: "", value: "" },
      responsible: { id: 0, name: "", avatar: "" },
    },
    onSubmit: () => {},
  });

  const branchId = useMemo(() => user?.branch?.id, [user?.branch?.id]);
  const debounceFormValues = useDebounce(formik.values, 300);

  const { data: ticketsResponse, isLoading: isLoadingTickets } =
    useGetAllTicketsQuery(
      {
        branch_id: branchId,
        search: debounceFormValues.search,
        state: debounceFormValues.state.value,
        responsible: debounceFormValues.responsible.name,
      },
      {
        skip: !branchId,
      }
    );

  const supportStaffQuery = useGetSupportStaffTicketsQuery({});

  const supportStaff = useMemo(() => {
    if (!supportStaffQuery.data) return [];

    const data: Array<any> = supportStaffQuery.data?.data.map((support) => ({
      ...support,
      avatar:
        support?.avatar ??
        "https://dash.fitmewise.com/uploads/users/profile.png",
    }));

    data.unshift({
      id: 0,
      name: t("all_status") || "Todos los estados",
    });

    return data;
  }, [supportStaffQuery.data]);

  return (
    <div className="px-6 mt-8">
      {/* Pass the raw tickets data and the callback to NavbarFilterTickets */}
      <div className="flex flex-col max-w-3xl md:flex-row gap-y-2 w-full items-center  gap-5">
        <InputWithCornerHint
          label="Nombre"
          span=""
          id="name"
          name="name"
          type="text"
          className="w-full"
          placeholder="Nombre de cliente o email"
          value={formik.values.search}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            formik.setFieldValue("search", e.target.value)
          }
        />
        <Select
          name=""
          selected={formik.values.state}
          setSelected={(option) => {
            formik.setFieldValue("state", option);
          }}
          options={stateTickets}
          tittle="Estado"
        />
        <SelectAvatar
          className="min-w-[200px] w-full"
          selected={formik.values.responsible}
          setSelected={(option) => {
            formik.setFieldValue("responsible", option);
          }}
          options={supportStaff}
          tittle="Responsable"
        />
      </div>
      <div>
        <TableListTickets
          tickets={ticketsResponse?.tickets?.data}
          openModal={(ticket: TicketsPageProps) => {
            setCurrenTicket(ticket);
            setOpenModalIncidence(true);
          }}
          loading={isLoadingTickets}
        />
      </div>

      <IncidenceModal
        open={openModalIncidence}
        setOpen={setOpenModalIncidence}
        data={currenTicket}
        usersSupportStaff={supportStaff}
      />
    </div>
  );
};
